import { $fetch } from '@/plugins/Fetch'

export default {
  methods: {
    // 客服系统签名 customer_service/get_encrypted_signature
    getEncryptedSign (data) {
      return $fetch('customer_service/get_encrypted_signature', {
        method: 'POST',
        body: data,
      })
    },
    // 获取工单列表
    getWorkOrderList (data) {
      return $fetch('/customer_service/get_work_order_list', {
        method: 'POST',
        body: data,
      })
    },
    // 获取工单详情
    getWorkOrderDetail (data) {
      return $fetch('/customer_service/get_work_order_info', {
        method: 'POST',
        body: data,
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/modules/Udesk.js